let timerId = null;
const L_TIMEOUT_MS = 3600 * 1000; // 1hr seconds (adjust)

export const startLogOutTimer = (onTimeout) => {
  //console.log("timer running")
  clearLogoutTimer();
  timerId = setTimeout(() => {
    onTimeout();
    //console.log("timer expired")
  }, L_TIMEOUT_MS);
};

export const resetLogOutTimer = (onTimeout) => {
  startLogOutTimer(onTimeout);
};

export const clearLogoutTimer = () => {
  if (timerId) {
    clearTimeout(timerId);
    timerId = null;
  }
};
